import styled from 'styled-components';

export const BodyCamera = styled.div`
display: flex ;
flex-direction: column;
align-items:center ;
align-content: center ;

.fundoBloque{
  display: ${props => props.fundoBloque ? 'flex' : 'none'} ;
  width: 100vw;
  height: 100vh; 
  background-color: black ;
  position: fixed ;
  top:0 ;
  bottom:0 ;
  z-index: 2 ;
  };
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
  background: linear-gradient(140deg, #44456b 0%, #15ff00 100%);
  position: fixed;
  z-index: 2;
  height: 100vh;
  top:0 ;
  font-weight: bold;
`;

export const CameraWrapper = styled.div`
  position: relative;
  width: 90vw;
  max-width: 500px;
  min-height: 400px;
  border: 3px solid ${props => {
    if (!props.ativo) return 'transparent';
    return props.rostoDetectado ? '#1eff00' : '#e74949';
  }};
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  transition: border-color 0.3s ease;
  z-index: 2;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
`;

export const Canvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const Status = styled.div`
  color: black;
  font-size: 18px;
  font-weight: bold;
  min-height: 30px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

export const Button = styled.button`
  padding: 12px 30px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &.iniciar {
    background-color: #384cff;
    color: white;
    
    &:hover {
      background-color: #001aff;
      transform: scale(1.05);
    }
    
    &:disabled {
      background-color: #ff0000;
    }
  }
  
  &.parar {
    background-color: #ef4444;
    color: white;
    
    &:hover {
      background-color: #dc2626;
      transform: scale(1.05);
    }
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
